import React from 'react';

// آیکون‌های دکمه‌های صفحه‌ی سه‌بعدی — خطی، ۲۴×۲۴، رنگ از currentColor
function Svg({ size = 20, children, strokeWidth = 1.8 }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export const IconCube = (p) => (
  <Svg {...p}>
    <path d="M12 2.8 20 7.2v9.6L12 21.2 4 16.8V7.2Z" />
    <path d="M4 7.2 12 11.6l8-4.4M12 11.6v9.6" />
  </Svg>
);

export const IconWalk = (p) => (
  <Svg {...p}>
    <circle cx="13" cy="4.2" r="1.8" />
    <path d="m9.5 21 2-6.2 2.6 2.4V21M8 11.5l2.8-3.6c.6-.8 1.8-.9 2.5-.2l3.2 3.1 2.5.6" />
    <path d="m11.5 14.8.9-4.6" />
  </Svg>
);

export const IconPlan = (p) => (
  <Svg {...p}>
    <rect x="3.5" y="3.5" width="17" height="17" rx="2.5" />
    <path d="M3.5 11h7V3.5M10.5 11v9.5M14 14.5h6.5" />
  </Svg>
);

export const IconSparkle = (p) => (
  <Svg {...p}>
    <path d="M12 3.5c.6 3.9 2.6 5.9 6.5 6.5-3.9.6-5.9 2.6-6.5 6.5-.6-3.9-2.6-5.9-6.5-6.5 3.9-.6 5.9-2.6 6.5-6.5Z" />
    <path d="M18.5 16v4M16.5 18h4" />
  </Svg>
);

export const IconSun = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2.5v2M12 19.5v2M4.6 4.6 6 6M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4" />
  </Svg>
);

export const IconPause = (p) => (
  <Svg {...p}>
    <path d="M9 5.5v13M15 5.5v13" strokeWidth="2.4" />
  </Svg>
);

export const IconPlay = (p) => (
  <Svg {...p}>
    <path d="M8 5.5v13l10.5-6.5Z" fill="currentColor" />
  </Svg>
);

export const IconStop = (p) => (
  <Svg {...p}>
    <rect x="6.5" y="6.5" width="11" height="11" rx="2" fill="currentColor" />
  </Svg>
);

export const IconClose = (p) => (
  <Svg {...p}>
    <path d="M6.5 6.5 17.5 17.5M17.5 6.5 6.5 17.5" strokeWidth="2" />
  </Svg>
);

export const IconSofa = (p) => (
  <Svg {...p}>
    <path d="M5 11V8.5A2.5 2.5 0 0 1 7.5 6h9A2.5 2.5 0 0 1 19 8.5V11" />
    <path d="M3.5 12.5a1.8 1.8 0 0 1 3.5 0V14h10v-1.5a1.8 1.8 0 0 1 3.5 0V17a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 17Z" />
    <path d="M6 18.5V20M18 18.5V20" />
  </Svg>
);

export const IconBed = (p) => (
  <Svg {...p}>
    <path d="M3 18.5V6.5M3 14h18v4.5M21 14v-2.5A2.5 2.5 0 0 0 18.5 9H11v5" />
    <circle cx="7" cy="11" r="1.8" />
  </Svg>
);

export const IconUndo = (p) => (
  <Svg {...p}>
    <path d="M9 14 4.5 9.5 9 5" />
    <path d="M4.5 9.5h9.5a5.5 5.5 0 0 1 0 11H11" />
  </Svg>
);

export const IconGlasses = (p) => (
  <Svg {...p} strokeWidth={1.7}>
    <circle cx="6.5" cy="14" r="3.6" />
    <circle cx="17.5" cy="14" r="3.6" />
    <path d="M10.1 13.4c1.2-.9 2.6-.9 3.8 0M2.9 13.2 4.6 7.4c.3-.9 1.1-1.4 2-1.4M21.1 13.2l-1.7-5.8c-.3-.9-1.1-1.4-2-1.4" />
  </Svg>
);

export const IconServer = (p) => (
  <Svg {...p}>
    <rect x="4" y="4" width="16" height="7" rx="2" />
    <rect x="4" y="13" width="16" height="7" rx="2" />
    <path d="M8 7.5h.01M8 16.5h.01" strokeWidth="2.6" />
  </Svg>
);

export const IconDevice = (p) => (
  <Svg {...p}>
    <rect x="6.5" y="2.8" width="11" height="18.4" rx="2.5" />
    <path d="M11 18h2" />
  </Svg>
);

export const IconUpload = (p) => (
  <Svg {...p}>
    <path d="M7 17.5H6a4 4 0 0 1-.6-7.95A6 6 0 0 1 17 8.6h.2a4.5 4.5 0 0 1 .8 8.9" />
    <path d="M12 20.5v-8.5M8.8 15.2 12 12l3.2 3.2" />
  </Svg>
);

export const IconCheck = (p) => (
  <Svg {...p}>
    <path d="m5 12.5 4.5 4.5L19 7.5" />
  </Svg>
);
